var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOcupationCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.472,
    height: 53.272,
    viewBox: "0 0 57.472 53.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15792",
    "data-name": "Group 15792",
    transform: "translate(-1230.663 -1703.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15790",
    "data-name": "Group 15790",
    transform: "translate(1239.261 1754.43) rotate(-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65377",
    "data-name": "Path 65377",
    d: "M16.89,12.667A54.145,54.145,0,0,0,0,30.965M5.63,22.52C-1.869,6.026,13.61.663,25.123.044c1.389-.075,2.084-.112,2.583.369s.47,1.167.413,2.539C27.641,14.361,22.5,29.858,5.63,22.52Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65381",
    "data-name": "Path 65381",
    d: "M56.014,16.18h.053a10.637,10.637,0,0,1,3.545,20.664m-3.6-20.664q.052-.584.053-1.182a13,13,0,0,0-13-13c-6.8,0-12.262,4.6-12.834,11.251M56.014,16.18A12.94,12.94,0,0,1,53.1,23.27",
    transform: "translate(1219.933 1703)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65382",
    "data-name": "Path 65382",
    d: "M2.171,0C5.5,1.717,7.1,5.265,7.1,9.382A10.287,10.287,0,0,1,0,19.127",
    transform: "translate(1238.218 1723.835) rotate(-94)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcupationCard1);
export default __webpack_public_path__ + "static/media/OcupationCard1.00dc0b00ff60ef5d19aa07d043678d0c.svg";
export { ForwardRef as ReactComponent };